import React from "react";
import Nav from "./Nav";
import ProductsSection from "./ProductsSection";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

const ProductsPage = () => (
  <div className="App">
    <title>AI Products — EffiGen LLC</title>
    <meta
      name="description"
      content="Explore AI products designed and built by EffiGen LLC: WakaTaka, PavEye, Name Pilot, Social Arc, and Agent Moot."
    />
    <link rel="canonical" href="https://effigen.ai/products" />
    <Nav />
    <main>
      <ProductsSection />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default ProductsPage;
